import logo from "assets/images/dark_logo.png";
import Sheet from "components/Overlays/AnimatedSheet";
import { useCallback, useEffect, useRef, useState } from "react";
import { AiOutlineLoading3Quarters, AiOutlineLogout, AiOutlineMenu } from "react-icons/ai";
import { FiX } from "react-icons/fi";
import { BsTelephoneForward } from "react-icons/bs";
import { IoCloudDownloadOutline } from "react-icons/io5";
import { NavLink, useLocation } from "react-router-dom";
import useLogout from "api/UserResource/useLogout";
import useNavigationDrawer from "layouts/Admin2/useNavigationDrawer";
import useNavigationLinks from "./useNavigationLinks";
import CurrencyConverter from "./CurrencyConverter";
import ProfileIcon from "./ProfileIcon";

const MobileMenu = ({ isAuthenticated }) => {
    const menu = useNavigationLinks();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const drawerRef = useRef(null), triggerRef = useRef(null);
    const close = useCallback(() => setOpen(false), []);
    useNavigationDrawer(open, close, drawerRef, triggerRef);
    useEffect(() => { close(); }, [location.pathname, location.search, close]);
    const { mutateAsync, isLoading } = useLogout();

    return <>
        <button type="button" ref={triggerRef} className="site-header-icon" onClick={() => setOpen(true)} aria-label="Open navigation menu" aria-expanded={open} aria-haspopup="dialog" aria-controls={open ? 'library-mobile-navigation' : undefined}>
            <AiOutlineMenu className="text-akgreenest" size={24} aria-hidden="true" />
        </button>
        <Sheet visible={open} position="left" onHide={close} blockScroll closeOnEscape={false} showCloseIcon={false} className="library-navigation-sheet" onShow={() => drawerRef.current?.querySelector('button')?.focus()}>
            <div id="library-mobile-navigation" role="dialog" aria-modal="true" aria-label="Library navigation" ref={drawerRef} className="library-navigation">
                <div className="library-navigation-heading">
                    <NavLink to="/" onClick={close}><img src={logo} alt="Akello Library" width={80} /></NavLink>
                    <button type="button" onClick={close} className="site-header-icon" aria-label="Close navigation menu"><FiX size={24} aria-hidden="true" /></button>
                </div>
                <nav aria-label="Main navigation">
                    {menu.map((item) => <NavLink key={item.to} exact to={item.to} onClick={close} activeClassName="is-active" isActive={item.to.includes('?') ? (match) => Boolean(match) && new URLSearchParams(location.search).get('auth') === new URLSearchParams(item.to.split('?')[1]).get('auth') : undefined}>{item.icon}<span>{item.label}</span></NavLink>)}
                    <NavLink to="/support" onClick={close}><BsTelephoneForward aria-hidden="true" /><span>Support</span></NavLink>
                    <NavLink to="/downloads" onClick={close}><IoCloudDownloadOutline aria-hidden="true" /><span>Downloads</span></NavLink>
                </nav>
                <div className="library-navigation-tools">
                    <label><span>Display currency</span><CurrencyConverter /></label>
                    {isAuthenticated && <>
                        <ProfileIcon menuId="mobile-profile-menu" label="My account" />
                        <button type="button" onClick={async () => { close(); await mutateAsync(); }} disabled={isLoading}>
                            {isLoading ? <AiOutlineLoading3Quarters className="animate-spin" aria-hidden="true" /> : <AiOutlineLogout aria-hidden="true" />}<span>{isLoading ? 'Signing out…' : 'Logout'}</span>
                        </button>
                    </>}
                </div>
            </div>
        </Sheet>
    </>;
};
export default MobileMenu;
